import { makeOpenSolarStyles } from 'themes/makeOpenSolarStyles'

export const useComponentActionStyles = makeOpenSolarStyles(
  () => ({
    button: { padding: 0, width: 24, height: 24 },
    icon: { color: '#CCC', width: 18, height: 18 },
  }),
  { name: 'ComponentAction' }
)
